import * as React from "react";

import { cn } from "@/app/_lib/utils";

/**
 * The site-wide content rail. Matches the nav/footer geometry exactly:
 * `max-w-[1500px]` cap, `px-[100px]` outer margin, `border-x` inner rail, and
 * standard inner padding. Every public section should sit inside a Rail so the
 * vertical rail lines line up with the nav and footer.
 */
export interface RailProps {
  children: React.ReactNode;
  /** Draw the bottom divider under the section. */
  bottom?: boolean;
  className?: string;
  /** Override the inner padding / layout of the bordered rail. */
  innerClassName?: string;
  as?: keyof JSX.IntrinsicElements;
  id?: string;
}

export function Rail({
  children,
  bottom = false,
  className,
  innerClassName,
  as: Tag = "section",
  id,
}: RailProps) {
  return (
    <Tag
      id={id}
      className={cn(
        "mx-auto max-w-[1500px] px-3 md:px-[100px]",
        bottom && "border-b border-border",
        className,
      )}
    >
      <div
        className={cn(
          "border-x border-border px-3 md:px-14",
          innerClassName,
        )}
      >
        {children}
      </div>
    </Tag>
  );
}
